import gql from 'graphql-tag';

export const eventReportDataFragment = gql`
  fragment EventReportDataParts on EventReportData {
    eventId: eventid
    eventDate: eventdate
    eventTime: eventtime
    eventType: eventtype
    eventTypeValue: eventtypevalue
    placeName: placename
    placeId: placeid
    condominiumPersonContextId: condominiumpersoncontextid
    personName: personname
    personProfile: personprofile
    unityGroupName: unitygroupname
    unityName: unityname
    treatmentEndDate: treatmentenddate
    treatmentEndTime: treatmentendtime
    attendantProfile: attendantprofile
    attendantName: attendantname
    additionalInformation: additionalinformation
    deviceName: devicename
    eventCreationDate: eventcreationdate
    treatment
  }
`;
